import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback } from 'react';
import { Badge, Button } from '@mui/material';
import { Update } from '@mui/icons-material';
import { useUpgradeExtensionsDialog } from 'features/device.settings.upgrade-extensions/ui/dialog';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { useHasAccessoriesFirmwareUpdate } from 'entities/device.service.accessories.upgrade/lib/check';
import { BoilerAdapter, IOExtension } from 'z3k-config';
function getInfo(io_extension, boiler_adapter) {
    if (io_extension) {
        const { hw, updater } = IOExtension.getHardwareAndSoftwareVersion(io_extension);
        return {
            hw,
            can_update: !!updater,
            serial: io_extension.serial,
            name: io_extension.name,
            id: io_extension.id,
        };
    }
    if (boiler_adapter) {
        const { hw, updater } = BoilerAdapter.getHardwareAndSoftwareVersion(boiler_adapter);
        return {
            hw,
            can_update: !!updater,
            serial: boiler_adapter.serial.value,
            name: boiler_adapter.name,
            id: boiler_adapter.id,
        };
    }
    return { hw: -1, serial: '', name: '?', can_update: false, id: -1 };
}
export const UpdateAccessoriesButton = memo(function UpdateAccessoriesButtonImpl(props) {
    const { device_id, io_extension, boiler_adapter, ...rest } = props;
    const { hw, can_update, name, serial, id } = getInfo(io_extension, boiler_adapter);
    const show_need_updates = useHasAccessoriesFirmwareUpdate(device_id, id);
    const [UpgradeExtensionsDialog, open] = useUpgradeExtensionsDialog();
    const onClick = useCallback(() => {
        if (device_id != null) {
            open();
        }
    }, [device_id]);
    if (!can_update || device_id == null) {
        return null;
    }
    return (_jsxs(ErrorBoundary, { children: [_jsx(Badge, { badgeContent: show_need_updates ? 1 : 0, color: "error", children: _jsxs(Button, { onClick: onClick, variant: "outlined", color: "primary", startIcon: _jsx(Update, {}), size: "small", ...rest, children: ["\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C", ' '] }) }), _jsx(UpgradeExtensionsDialog, { device_id: device_id, name: name, serial: serial, hw_type: hw })] }));
});
